import React, { useEffect, useState } from 'react';
import './css/NewsSection.css';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import axios from 'axios';
import { newsItems as allNewsItems } from '../data/newsData';

const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

const FALLBACK_IMAGE =
  'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="800" height="600" viewBox="0 0 800 600"%3E%3Crect fill="%23010727" width="800" height="600"/%3E%3Ctext fill="%23fff" font-family="sans-serif" font-size="18" x="50%25" y="50%25" dominant-baseline="middle" text-anchor="middle"%3EImage%3C/text%3E%3C/svg%3E';

const defaultNews = allNewsItems.slice(0, 6).map((item) => ({
  id: item.id,
  date: item.date,
  title: item.title,
  heroImage: item.heroImage,
}));

const NewsSection = () => {
  const [newsItems, setNewsItems] = useState(defaultNews);

  useEffect(() => {
    const fetchNews = async () => {
      try {
        const res = await axios.get(
          `${API_BASE_URL}/api/news/section-cards`
        );
        if (Array.isArray(res.data?.cards)) {
          setNewsItems(res.data.cards);
        }
      } catch (err) {
        // eslint-disable-next-line no-console
        console.error(err);
      }
    };

    fetchNews();
  }, []);

  return (
    <motion.section
      className="news-section"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: 0.7, ease: 'easeOut' }}
    >
      <div className="container">
        <div className="news-header news-header-row mb-5">
          <h2 className="news-main-title">News & Insights</h2>
          <p className="news-intro-text">
            Stay informed with the latest updates from Whales Advisory—regulatory changes,
            firm news, and insights for businesses and investors.
          </p>
        </div>

        <div className="news-slider-container">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={24}
            loop={true}
            
            pagination={{ clickable: true }}
            autoplay={{ delay: 6000, disableOnInteraction: false }}
            breakpoints={{
              0: {
                slidesPerView: 1,
              },
              576: {
                slidesPerView: 1.3,
                centeredSlides: true,
              },
              768: {
                slidesPerView: 2,
              },
              1200: {
                slidesPerView: 3,
              },
            }}
          >
            {newsItems.map((item) => {
              const imageSrc = !item.heroImage
                ? ''
                : item.heroImage.startsWith('http')
                  ? item.heroImage
                  : `${API_BASE_URL}${item.heroImage}`;

              return (
              <SwiperSlide key={item.id}>
                <Link
                  to={`/news/${item.id}`}
                  className="news-card-link"
                >
                  <article className="news-card">
                    <div className="news-image-container">
                      <img
                        src={imageSrc}
                        alt={item.title}
                        className="news-img"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = FALLBACK_IMAGE;
                        }}
                      />
                    </div>
                    <div className="news-info-box">
                      <div className="info-text">
                        <p className="news-date">{item.date}</p>
                        <h4 className="news-title">{item.title}</h4>
                      </div>
                      <div className="news-arrow-icon">→</div>
                    </div>
                  </article>
                </Link>
              </SwiperSlide>
              );
            })}
          </Swiper>
        </div>
      </div>
    </motion.section>
  );
};

export default NewsSection;
